import {
  React,
  Component,
  PropTypes,
  helpers,
} from 'imports/CommonImports';

import {
  GreyColor1,
} from 'imports/DesignImports';

import DataTables from 'material-ui-datatables';

import {
  Paper,
} from 'material-ui';

const styles = {
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '20em',
  },
  header: {
    marginLeft: '1em',
  },
  listContainer: {
    padding: '0 1em',
  },
  listItem: {
    padding: '1em',
    margin: '0',
    borderBottom: '1px solid',
    borderBottomColor: GreyColor1,
  },
}
class ProjectSummaryList extends Component {
  state = {
    now: this.props.years ? this.props.years : new Date(Date.now()),
  }

  componentDidMount() {
    this.setTable();
  }

  render() {
    return (
      <Paper style={{...styles.paper, ...this.props.style}}>
        <div style={styles.headerContainer}>
          <p style={styles.header}><b>{this.props.header}</b></p>
        </div>
        <DataTables
          height={'auto'}
          showRowHover={false}
          columns={this.state.tableColumns}
          data={this.state.tableData}
          showFooterToolbar={false}
          onCellClick={this.handleCellClick}
          onSortOrderChange={this.handleSortOrderChange}
          onRowSelection={this.handleRowSelection}
          page={1}
          count={100}
          tableHeaderStyle={styles.tableHeader}
          tableHeaderColumnStyle={styles.tableHeaderColumn}
          tableRowStyle={styles.tableRow}
          tableRowColumnStyle={styles.tableRowColumn}
          footerToolbarStyle={styles.footerToolbar}
          ref={(table) => this.table = table}
        />
      </Paper>
    );
  }

  setTable = () => {
    var tableColumns = [
      {
      key: 'id',
      label: '#',
      sortable: false,
      render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
      },
      {
      key: 'name',
      label: 'Nombre',
      sortable: false,
      render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
      },
      {
      key: 'firstYear',
      label: this.props.years ? this.props.years[0].year : this.state.now.getFullYear() - 1,
      sortable: false,
      render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
      },
      {
      key: 'secondYear',
      label: this.props.years ? this.props.years[1].year : this.state.now.getFullYear(),
      sortable: false,
      render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
      },
      {
      key: 'thirdYear',
      label: this.props.years ? this.props.years[2].year : this.state.now.getFullYear() + 1,
      sortable: false,
      render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
      },
    ]
    var tableData = this.props.projects.map((project, index) => {
      return {
        id: index + 1,
        name: project.name,
        firstYear: "$ "+ helpers.numberWithDots((Number(project.values[0]) / 1000000).toFixed(3)).replace('.',',') + "M",
        secondYear: "$ "+ helpers.numberWithDots((Number(project.values[1]) / 1000000).toFixed(3)).replace('.',',') + "M",
        thirdYear: "$ "+ helpers.numberWithDots((Number(project.values[2]) / 1000000).toFixed(3)).replace('.',',') + "M",
      }
    })
    this.setState({
      tableColumns: tableColumns,
      tableData: tableData,
      loadingData: false,
    });
  }
}

ProjectSummaryList.propTypes = {
  style: PropTypes.object,
  title: PropTypes.string,
  projects: PropTypes.array,
}

ProjectSummaryList.defaultProps = {
  style: {},
  header: 'Proyectos medidos',
  projects: [
      {id: 1, name: 'Digitalización de procesos financieros'},
      {id: 2, name: 'Producción en seco de fruta'},
      {id: 3, name: 'Riego automatizado para campos en pendiente'},
    ]
}
export default ProjectSummaryList;



// WEBPACK FOOTER //
// ./src/components/dashboard/ProjectSummaryList.js